import { REVENUE_RECOGNITION_TYPE, type RevenueRecognitionType } from '@vy/types';

export type { RevenueRecognitionType } from '@vy/types';

export type RecognitionOption = {
  key: RevenueRecognitionType;
  label: string;
  description: string;
  disabled?: boolean;
};

export type RevenuePoint = {
  date: Date;
  amount: number;
};

export const REVENUE_RECOGNITION_OPTIONS: readonly RecognitionOption[] = [
  { key: REVENUE_RECOGNITION_TYPE.PointInTime, label: 'Point-in-Time', description: 'Recognize the full amount on a single date' },
  { key: REVENUE_RECOGNITION_TYPE.Milestones, label: 'Milestones', description: 'Recognize across multiple dated milestones' },
  { key: REVENUE_RECOGNITION_TYPE.StraightLine, label: 'Straight-Line', description: 'Evenly over time' },
  { key: REVENUE_RECOGNITION_TYPE.UsageBased, label: 'Usage-Based', description: 'As usage occurs', disabled: true },
];

export const SUM_TOLERANCE = 0.01;
